export const type_lookup = [
  '',
  'Noise',
  'Vibration',
  'Dust',
  'Met'
]

export const complete_type_lookup = [
  '',
  [
    'Noise - Leq',
    'Noise - 1/1 1/3 Octave'
  ],
  [
    'Vibration - Vibra',
    'Vibration - PPVDV',
    'Vibration - PPVDV',
    'Vibration - PPVDV'
  ], 
  [
    'Dust - MetOne',
    'Dust - TSI'
  ],
  [
    'Met',
    'Met'
  ]
]

export const status_codes = {
  success: 200
}

export const status_states = {
  pending: 'pending',
  success: 'success',
  error: 'error'
}

// Display texts for different results when click on the `Test Now` button
export const test_messages = {
  test_now: 'RV-50 connection test',
  loading: 'Loading...',
  failed: 'Failed',
  capable: 'Capable of controlling RV-50',
  not_capable: 'Unable to control RV-50'  
}

// Instrument types
export const instrument_types = {
  noise: 1,
  vibration: 2,
  dust: 3,
  met: 4
}

// Instrument sub types
export const instrument_sub_types = {
  vibra: 0,
  ppv: 1
}

// Commands for monitor
export const monitor_commands = {
  test_rv50: 'rv50_test'
}

// Potential responses when send test GET command
export const sub_commands = {    
  test_capable: '105',
  test_not_capable: '106'
}

